import { AxiosResponse } from 'axios'
import { axiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { PaginationBody } from '@Entities/pagination'
import { Sort } from '@Entities/search'
import { ResultPage } from '@Entities/result-page'
import {
    SongwriterSubmissionSuggestion,
    SongwriterSubmissionSuggestionStatus,
} from '@Entities/rightsholder/songwriter-submission-suggestion'

const defaultSuggestionSort: Sort = { field: 'createdAt', direction: 'desc' }

const withDefaultSuggestionSort = (pagination: PaginationBody): PaginationBody => ({
    ...pagination,
    sort: pagination.sort ?? defaultSuggestionSort,
})

export const getSongwriterSubmissionSuggestions = (
    rightsholderId: number,
    statuses: SongwriterSubmissionSuggestionStatus[],
    pagination: PaginationBody = { page: 1, limit: 20 }
): Promise<AxiosResponse<ResultPage<SongwriterSubmissionSuggestion>>> =>
    axiosClient.get<ResultPage<SongwriterSubmissionSuggestion>>(
        Pathes.RightsHolder.getSongwriterSubmissionSuggestions(
            rightsholderId,
            statuses,
            withDefaultSuggestionSort(pagination)
        )
    )

export const updateSongwriterSubmissionSuggestionStatus = (
    rightsholderId: number,
    suggestionId: number,
    status: Exclude<SongwriterSubmissionSuggestionStatus, 'SUBMITTED'>
): Promise<AxiosResponse<void>> =>
    axiosClient.patch<void>(
        Pathes.RightsHolder.updateSongwriterSubmissionSuggestionStatus(rightsholderId, suggestionId),
        undefined,
        {
            params: {
                status,
            },
        }
    )
